import { Fragment } from "react";
import _sortBy from "lodash/sortBy";
import PromoProduct from "@containers/Promo/PromoProduct";
import PromoProductFeatured from "@containers/Promo/PromoProduct/PromoProductFeatured";

const PromoProductsGrid = ({ products, sort, filters, campaign }) => {
  let productsList = [...products];
  const hasFilters = Object.keys(filters).length;
  const hasSort = sort !== "default";
  const isTeaser = campaign.is_teaser === 1;

  if (hasFilters) {
    productsList = productsList.filter((product) => {
      if (!Object.keys(product.filterable_attributes).length) {
        return false;
      }

      let isValid = true;

      for (const [filtername, filterValues] of Object.entries(filters)) {
        if (
          !product.filterable_attributes[filtername] ||
          (product.filterable_attributes[filtername] &&
            !filterValues.includes(product.filterable_attributes[filtername]))
        ) {
          isValid = false;
          break;
        }
      }

      return isValid;
    });
  }

  if (hasSort) {
    if (sort === "price") {
      productsList = _sortBy(productsList, (product) => product.final_price);
    }

    if (sort === "discount") {
      productsList = _sortBy(
        productsList,
        (product) =>
          product.final_price - (product.price || product.final_price)
      );
    }
  }

  if (!productsList.length && hasFilters) {
    return (
      <div className="lg:mt-25px text-center text-lg font-bold group-with-promoDarkTheme:text-white">
        Nu exista produse care sa corespunda filtrelor selectate.
      </div>
    );
  }

  if (!productsList.length) {
    return (
      <div className="lg:mt-25px text-center text-lg font-bold group-with-promoDarkTheme:text-white">
        Nu mai exista produse in aceasta categorie.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 grid-flow-row-dense -mx-2">
      {productsList.map((product) => {
        const isFeatured = product.display_type === 1;

        return (
          <Fragment key={product.id}>
            {isFeatured ? (
              <div
                key={product.id}
                className="col-span-2 Products-item p-1 md:p-2 border-2 border-transparent min-h-330px xl:min-h-400px"
              >
                <PromoProductFeatured product={product} isTeaser={isTeaser} />
              </div>
            ) : (
              <div
                key={product.id}
                className="col-span-1 Products-item p-1 md:p-2 border-2 border-transparent min-h-330px xl:min-h-400px"
              >
                <PromoProduct product={product} isTeaser={isTeaser} />
              </div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default PromoProductsGrid;
